// extracted by mini-css-extract-plugin
export default {"Step-two":"StepTwo_Step-two__A1qwW","grid-container":"StepTwo_grid-container__O9pB8","multi-image-label":"StepTwo_multi-image-label__i5Qxd","onPhone":"StepTwo_onPhone__xE1DN"};